module.exports = __webpack_public_path__ + "img/1902073.jpg";